import { URL_LABEL } from "../../../index.content";

const dropshipping = ({ language, isSavedUser }) => {
  return {
    title: "Dropshipping, Arbitrage, and Wholesale Extension for Amazon",
    url: isSavedUser
      ? "https://chrome.google.com/webstore/detail/amazon-dropshipping-arbit/edkgpjhfpfpgkohafpaliolcfnijnibh?utm_source=site&utm_medium=amzscout&utm_campaign=footer"
      : `/online-arbitrage/?${URL_LABEL}`,
    target: isSavedUser,
    ref: true,
    isLink: !isSavedUser,
  };
};

export default dropshipping;
